import {
  Card,
  Form,
  Button,
  message,
  Row,
  Col,
  Radio,
  Image,
  Descriptions,
  Modal,
  Divider,
  Upload,
  Input,
} from "antd"
import { AiOutlineEye, AiOutlineExclamationCircle } from "react-icons/ai"
import { FaCamera } from "react-icons/fa"
import * as API from "common/api"
import * as COMMONS from "common/common"
import "moment/locale/ja"
import React, { useState } from "react"
import { useMutation, useQuery, useQueryClient } from "react-query"
import { Helmet } from "react-helmet-async"
import { useNavigate } from "react-router-dom"
import styled from "styled-components"

const checkRichMenuImageSize = (type, param, callback) => {
  const isSt1M = param.file.size / 1024 / 1024 < 1

  if (isSt1M) {
    const reader = new FileReader()
    reader.readAsDataURL(param.file)
    reader.addEventListener("load", (event) => {
      const _loadedImageUrl = event.target.result
      const image = document.createElement("img")

      image.src = _loadedImageUrl
      image.addEventListener("load", async () => {
        const { width, height } = image

        if (type === "defaultRM") {
          if (width === 1200 && height === 810) {
            callback({
              file: param.file,
              preview: _loadedImageUrl,
            })
          } else {
            message.warning(COMMONS.WARN_IMAGE_SIZE_DIFFERENT)
          }
        } else if (type === "memberRM") {
          if (width === 1200 && height === 810) {
            callback({
              file: param.file,
              preview: _loadedImageUrl,
            })
          } else {
            message.warning(COMMONS.WARN_IMAGE_SIZE_DIFFERENT)
          }
        }
      })
    })
  } else {
    message.warning(COMMONS.WARN_IMAGE_TOO_BIG)
  }
}

const CustomUpload = styled(Upload)`
  .ant-upload {
    width: 100%;
  }
`

const RichMenu = () => {
  const navigate = useNavigate()

  const isMountedRef = COMMONS.USE_IS_MOUNTED_REF()
  const queryClient = useQueryClient()

  const [defaultRichMenuForm] = Form.useForm()
  const [memberRichMenuForm] = Form.useForm()

  const [defaultRichMenuImageFile, setDefaultRichMenuImageFile] =
    useState(undefined)
  const [memberRichMenuImageFile, setMemberRichMenuImageFile] =
    useState(undefined)

  const [richMenus, setRichMenus] = useState([])
  const [isDefaultRichMenuModalVisible, setIsDefaultRichMenuModalVisible] =
    useState(false)
  const [isMemberRichMenuModalVisible, setIsMemberRichMenuModalVisible] =
    useState(false)

  useQuery([API.QUERY_KEY_ADMIN_RICHMENUS], () => API.ADMIN_GET_RICHMENUS(), {
    onSuccess: (response) => {
      if (isMountedRef.current) {
        setRichMenus(response?.data || {})
      }
    },
    onError: (error) => {
      if (error?.response?.status === COMMONS.RESPONSE_PERMISSION_ERROR) {
        navigate(COMMONS.PERMISSION_ERROR_ROUTE)
      } else if (error?.response?.status === COMMONS.RESPONSE_SESSION_ERROR) {
        message.warning(COMMONS.ERROR_SESSION_MSG)
        navigate(COMMONS.ADMIN_LOGIN_ROUTE)
      } else if (error?.response?.status === COMMONS.RESPONSE_SYSTEM_ERROR) {
        message.error(COMMONS.ERROR_SYSTEM_MSG)
      } else {
        message.error(COMMONS.ERROR_SYSTEM_MSG)
      }
    },
  })

  const richMenuUpdateMutation = useMutation(API.ADMIN_UPDATE_RICHMENU, {
    onSuccess: () => {
      if (isMountedRef.current) {
        message.success(COMMONS.SUCCESS_UPDATE_MSG)
        queryClient.invalidateQueries(API.QUERY_KEY_ADMIN_RICHMENUS)
      }
    },
    onError: (error) => {
      if (error?.response?.status === COMMONS.RESPONSE_PERMISSION_ERROR) {
        navigate(COMMONS.PERMISSION_ERROR_ROUTE)
      } else if (error?.response?.status === COMMONS.RESPONSE_SESSION_ERROR) {
        message.warning(COMMONS.ERROR_SESSION_MSG)
        navigate(COMMONS.ADMIN_LOGIN_ROUTE)
      } else if (error?.response?.status === COMMONS.RESPONSE_SYSTEM_ERROR) {
        message.error(COMMONS.ERROR_SYSTEM_MSG)
      } else {
        message.error(COMMONS.ERROR_SYSTEM_MSG)
      }
    },
  })

  const richMenuDeleteMutation = useMutation(API.ADMIN_DELETE_RICHMENU, {
    onSuccess: () => {
      if (isMountedRef.current) {
        message.success(COMMONS.SUCCESS_DELETE_MSG)
        queryClient.invalidateQueries(API.QUERY_KEY_ADMIN_RICHMENUS)
      }
    },
    onError: (error) => {
      if (error?.response?.status === COMMONS.RESPONSE_PERMISSION_ERROR) {
        navigate(COMMONS.PERMISSION_ERROR_ROUTE)
      } else if (error?.response?.status === COMMONS.RESPONSE_SESSION_ERROR) {
        message.warning(COMMONS.ERROR_SESSION_MSG)
        navigate(COMMONS.ADMIN_LOGIN_ROUTE)
      } else if (error?.response?.status === COMMONS.RESPONSE_SYSTEM_ERROR) {
        message.error(COMMONS.ERROR_SYSTEM_MSG)
      } else {
        message.error(COMMONS.ERROR_SYSTEM_MSG)
      }
    },
  })

  const richMenuVisibilityMutation = useMutation(
    API.ADMIN_UPDATE_RICHMENU_VISIBILITY,
    {
      onSuccess: () => {
        message.success(COMMONS.SUCCESS_UPDATE_MSG)
        queryClient.invalidateQueries(API.QUERY_KEY_ADMIN_RICHMENUS)
      },
      onError: (error) => {
        if (error?.response?.status === COMMONS.RESPONSE_PERMISSION_ERROR) {
          navigate(COMMONS.PERMISSION_ERROR_ROUTE)
        } else if (error?.response?.status === COMMONS.RESPONSE_SESSION_ERROR) {
          message.warning(COMMONS.ERROR_SESSION_MSG)
          navigate(COMMONS.ADMIN_LOGIN_ROUTE)
        } else if (error?.response?.status === COMMONS.RESPONSE_SYSTEM_ERROR) {
          message.error(COMMONS.ERROR_SYSTEM_MSG)
        } else {
          message.error(COMMONS.ERROR_SYSTEM_MSG)
        }
      },
    }
  )

  const handleRichMenuVisibility = (type, isDisplayed) => {
    const paramData = {
      type: type,
      isDisplayed: isDisplayed,
    }

    Modal.confirm({
      title: "確認",
      content: (
        <p>
          <span style={{ color: COMMONS.PRIMARY_COLOR }}>
            「
            {type === "defaultRM"
              ? "登録前のリッチメニュー"
              : type === "memberRM"
              ? "登録後のリッチメニュー"
              : "ー"}
            」
          </span>
          を
          <span
            style={{
              color: COMMONS.PRIMARY_COLOR,
            }}
          >
            {isDisplayed ? "表示" : "非表示"}
          </span>
          してもよろしいでしょうか？
        </p>
      ),
      okText: "確認",
      okType: "primary",
      cancelText: "閉じる",
      centered: true,
      onOk() {
        richMenuVisibilityMutation.mutate(paramData)
      },
    })
  }

  const handleRichMenuUpdate = (type, field, data) => {
    if (type === "defaultRM") {
      const paramData = {
        type: type,
        isDisplayed: richMenus.defaultRM?.isDisplayed,
        picUrl: field.file ? field.file : undefined,
        link1: data.linkA || "",
        link2: data.linkB || "",
        link3: data.linkC || "",
      }

      richMenuUpdateMutation.mutate(paramData)
    } else if (type === "memberRM") {
      const paramData = {
        type: type,
        isDisplayed: richMenus.memberRM?.isDisplayed,
        picUrl: field.file ? field.file : undefined,
        link1: data.linkA || "",
        link2: data.linkB || "",
        link3: data.linkC || "",
      }

      richMenuUpdateMutation.mutate(paramData)
    }
  }

  const handleRichMenuDelete = (type) => {
    const paramData = {
      type: type,
    }

    Modal.confirm({
      title: "確認",
      icon: <AiOutlineExclamationCircle className="anticon text-red-600" />,
      content: "リッチメニューを削除してもよろしいでしょうか？",
      okText: "削除",
      okButtonProps: {
        size: "large",
        type: "primary",
        danger: true,
      },
      cancelText: "閉じる",
      cancelButtonProps: {
        size: "large",
      },
      centered: true,
      onOk() {
        richMenuDeleteMutation.mutate(paramData)
      },
    })
  }

  const showDefaultRichMenuModal = () => {
    if (richMenus?.defaultRM?.picUrl) {
      defaultRichMenuForm.setFieldsValue({
        richmenuImage: richMenus.defaultRM.picUrl,
        linkA: richMenus.defaultRM?.link1
          ? richMenus.defaultRM?.link1
          : undefined,
        linkB: richMenus.defaultRM?.link2
          ? richMenus.defaultRM?.link2
          : undefined,
        linkC: richMenus.defaultRM?.link3
          ? richMenus.defaultRM?.link3
          : undefined,
      })

      setDefaultRichMenuImageFile({
        preview: `${API.UPLOADS_URL}${richMenus.defaultRM.picUrl}`,
      })
    } else {
      defaultRichMenuForm.resetFields()
      setDefaultRichMenuImageFile(undefined)
    }

    setIsDefaultRichMenuModalVisible(true)
  }

  const hideDefaultRichMenuModal = () => {
    defaultRichMenuForm.resetFields()
    setDefaultRichMenuImageFile(undefined)

    setIsDefaultRichMenuModalVisible(false)
  }

  const showMemberRichMenuModal = () => {
    if (richMenus?.memberRM?.picUrl) {
      memberRichMenuForm.setFieldsValue({
        richmenuImage: richMenus.memberRM.picUrl,
        linkA: richMenus.memberRM?.link1
          ? richMenus.memberRM?.link1
          : undefined,
        linkB: richMenus.memberRM?.link2
          ? richMenus.memberRM?.link2
          : undefined,
        linkC: richMenus.memberRM?.link3
          ? richMenus.memberRM?.link3
          : undefined,
      })

      setMemberRichMenuImageFile({
        preview: `${API.UPLOADS_URL}${richMenus.memberRM.picUrl}`,
      })
    } else {
      memberRichMenuForm.resetFields()
      setMemberRichMenuImageFile(undefined)
    }

    setIsMemberRichMenuModalVisible(true)
  }

  const hideMemberRichMenuModal = () => {
    memberRichMenuForm.resetFields()
    setMemberRichMenuImageFile(undefined)

    setIsMemberRichMenuModalVisible(false)
  }

  return (
    <>
      <Helmet>
        <title>リッチメニュー設定 | {process.env.REACT_APP_SYSTEM_NAME}</title>
      </Helmet>
      <Card
        title="リッチメニュー設定"
        className="animate__animated animate__fadeIn"
        bordered={false}
      >
        <Row justify="between" align="top" gutter={[32, 32]}>
          <Col xs={24} lg={12}>
            <Card
              title="登録前のリッチメニュー設定"
              bordered={true}
              type="inner"
              extra={
                <div className="flex">
                  <Button
                    type="primary"
                    size="large"
                    className="w-26 m-1"
                    onClick={showDefaultRichMenuModal}
                  >
                    編集
                  </Button>
                  <Button
                    danger
                    type="primary"
                    size="large"
                    className="w-26 m-1"
                    onClick={() => {
                      handleRichMenuDelete("defaultRM")
                    }}
                    loading={richMenuDeleteMutation.isLoading}
                    disabled={richMenus.defaultRM ? false : true}
                  >
                    削除
                  </Button>
                </div>
              }
            >
              <div className="flex flex-col">
                <div className="flex flex-col items-center p-4 mb-4">
                  <p className="text-lg font-bold">登録前のリッチメニュー</p>
                  <p className="text-xs">
                    （このリッチメニューは、まだ会員ではないユーザーに表示されます）
                  </p>
                  {richMenus?.defaultRM?.richmenuId ? (
                    <div className="mt-4">
                      <Radio.Group
                        size="large"
                        optionType="button"
                        buttonStyle="solid"
                        options={[
                          { label: "表示", value: 1 },
                          { label: "非表示", value: 0 },
                        ]}
                        value={richMenus?.defaultRM?.isDisplayed ? 1 : 0}
                        onChange={(e) => {
                          handleRichMenuVisibility("defaultRM", e.target.value)
                        }}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="flex justify-center mb-4">
                  {richMenus?.defaultRM?.picUrl ? (
                    <Image
                      src={`${API.UPLOADS_URL}${richMenus.defaultRM.picUrl}`}
                      alt="登録前のリッチメニュー"
                      style={{
                        maxHeight: "250px",
                      }}
                      className="rounded object-contain w-full"
                      preview={{
                        mask: <AiOutlineEye />,
                        src: `${API.UPLOADS_URL}${richMenus.defaultRM.picUrl}`,
                        maskClassName: "rounded",
                      }}
                      fallback="/no-image.png"
                    />
                  ) : (
                    <Image
                      src="/template.png"
                      alt="登録前のリッチメニュー"
                      style={{
                        maxHeight: "250px",
                      }}
                      className="rounded object-contain w-full"
                      preview={false}
                    />
                  )}
                </div>
                <div className="flex justify-center">
                  <table>
                    <th></th>
                  </table>
                  <Descriptions
                    layout="vertical"
                    colon={false}
                    column={2}
                    bordered
                    className="w-full"
                    size="small"
                  >
                    <Descriptions.Item label="A部分のリンク先">
                      {richMenus?.defaultRM?.link1 || "ー"}
                    </Descriptions.Item>
                    <Descriptions.Item label="B部分のリンク先">
                      {richMenus?.defaultRM?.link2 || "ー"}
                    </Descriptions.Item>
                    <Descriptions.Item label=""></Descriptions.Item>
                    <Descriptions.Item label="C部分のリンク先">
                      {richMenus?.defaultRM?.link3 || "ー"}
                    </Descriptions.Item>
                  </Descriptions>
                </div>
              </div>
            </Card>
          </Col>
          <Col xs={24} lg={12}>
            <Card
              title="登録後のリッチメニュー設定"
              bordered={true}
              type="inner"
              extra={
                <div className="flex">
                  <Button
                    type="primary"
                    size="large"
                    className="w-26 m-1"
                    onClick={showMemberRichMenuModal}
                  >
                    編集
                  </Button>
                  <Button
                    danger
                    type="primary"
                    size="large"
                    className="w-26 m-1"
                    onClick={() => {
                      handleRichMenuDelete("memberRM")
                    }}
                    loading={richMenuDeleteMutation.isLoading}
                    disabled={richMenus.memberRM ? false : true}
                  >
                    削除
                  </Button>
                </div>
              }
            >
              <div className="flex flex-col">
                <div className="flex flex-col items-center p-4 mb-4">
                  <p className="text-lg font-bold">登録後のリッチメニュー</p>
                  <p className="text-xs">
                    （このリッチメニューは、会員のユーザーに表示されます）
                  </p>
                  {richMenus?.memberRM?.richmenuId ? (
                    <div className="mt-4">
                      <Radio.Group
                        size="large"
                        optionType="button"
                        buttonStyle="solid"
                        options={[
                          { label: "表示", value: 1 },
                          { label: "非表示", value: 0 },
                        ]}
                        value={richMenus?.memberRM?.isDisplayed ? 1 : 0}
                        onChange={(e) => {
                          handleRichMenuVisibility("memberRM", e.target.value)
                        }}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="flex justify-center mb-4">
                  {richMenus?.memberRM?.picUrl ? (
                    <Image
                      src={`${API.UPLOADS_URL}${richMenus.memberRM.picUrl}`}
                      alt="登録後のリッチメニュー"
                      style={{
                        maxHeight: "250px",
                      }}
                      className="rounded object-contain w-full"
                      preview={{
                        mask: <AiOutlineEye />,
                        src: `${API.UPLOADS_URL}${richMenus.memberRM.picUrl}`,
                        maskClassName: "rounded",
                      }}
                      fallback="/no-image.png"
                    />
                  ) : (
                    <Image
                      src="/template.png"
                      alt="登録後のリッチメニュー"
                      style={{
                        maxHeight: "250px",
                      }}
                      className="rounded object-contain w-full"
                      preview={false}
                    />
                  )}
                </div>
                <div className="flex justify-center">
                  <Descriptions
                    layout="vertical"
                    colon={false}
                    column={2}
                    bordered
                    className="w-full"
                    size="small"
                  >
                    <Descriptions.Item label="A部分のリンク先">
                      {richMenus?.memberRM?.link1 || "ー"}
                    </Descriptions.Item>
                    <Descriptions.Item label="B部分のリンク先">
                      {richMenus?.memberRM?.link2 || "ー"}
                    </Descriptions.Item>
                    <Descriptions.Item label=""></Descriptions.Item>
                    <Descriptions.Item label="C部分のリンク先">
                      {richMenus?.memberRM?.link3 || "ー"}
                    </Descriptions.Item>
                  </Descriptions>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </Card>
      <Modal
        title="登録前のリッチメニュー編集"
        visible={isDefaultRichMenuModalVisible}
        onCancel={hideDefaultRichMenuModal}
        footer={null}
        destroyOnClose
        centered
        bodyStyle={{
          maxHeight: "90vh",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        <div className="flex flex-col">
          <Divider>登録前のリッチメニュー</Divider>
          <div className="flex flex-col justify-center bg-amber-50 p-4 rounded mb-4">
            <Image
              src="/template.png"
              alt="テンプレート"
              preview={{
                mask: <AiOutlineEye />,
                src: "/template.png",
                maskClassName: "rounded",
              }}
              className="w-full rounded object-contain"
              fallback="/no-image.png"
            />
            <p className="my-4">
              リッチメニューの画像は以下の要件を満たす必要があります
            </p>
            <ol className="custom-ol list-none list-outside mb-2">
              <li>画像フォーマット：JPEGまたはPNG</li>
              <li>画像の幅サイズ（ピクセル）：1200px</li>
              <li>画像の高さサイズ（ピクセル）：810px</li>
              <li>最大ファイルサイズ：1MB</li>
            </ol>
          </div>
          <div className="border border-antd-gray p-4">
            <Form
              form={defaultRichMenuForm}
              onFinish={(data) => {
                handleRichMenuUpdate(
                  "defaultRM",
                  defaultRichMenuImageFile,
                  data
                )
              }}
              layout="vertical"
              requiredMark={false}
              preserve={false}
              initialValues={{
                richMenuImage: undefined,
              }}
              scrollToFirstError
            >
              <div className="flex flex-col">
                <Form.Item
                  name="richMenuImage"
                  className="whitespace-pre-wrap text-center"
                  help={`※このリッチメニューは、まだ会員ではないユーザーに\n表示されます`}
                  valuePropName="file"
                >
                  <CustomUpload
                    accept=".jpg, .jpeg, .png"
                    listType="picture"
                    maxCount={1}
                    showUploadList={false}
                    beforeUpload={() => {
                      return false
                    }}
                    onChange={async (param) => {
                      checkRichMenuImageSize(
                        "defaultRM",
                        param,
                        setDefaultRichMenuImageFile
                      )
                    }}
                  >
                    {defaultRichMenuImageFile?.preview ? (
                      <img
                        src={defaultRichMenuImageFile.preview}
                        alt="登録前のリッチメニュー"
                        style={{
                          maxHeight: "250px",
                        }}
                        className="w-full object-contain cursor-pointer"
                      />
                    ) : (
                      <div
                        style={{
                          height: "250px",
                          backgroundColor: "#fafafa",
                          border: "1px dashed #d9d9d9",
                        }}
                        className="flex justify-center items-center rounded cursor-pointer"
                      >
                        <Button
                          type="dashed"
                          icon={<FaCamera className="text-primary anticon" />}
                        >
                          アップロード
                        </Button>
                      </div>
                    )}
                  </CustomUpload>
                </Form.Item>
                <Divider />
                <Form.Item
                  name="linkA"
                  className="mt-4"
                  rules={[
                    {
                      type: "url",
                      message: "入力のURLが有効なURLではありません",
                    },
                  ]}
                >
                  <Input
                    addonBefore="A部分のリンク先："
                    placeholder={`例：${API.SITE_URL}`}
                    onPressEnter={(e) => e.preventDefault()}
                    allowClear
                  />
                </Form.Item>
                <Form.Item
                  name="linkB"
                  className="mt-4"
                  rules={[
                    {
                      type: "url",
                      message: "入力のURLが有効なURLではありません",
                    },
                  ]}
                >
                  <Input
                    addonBefore="B部分のリンク先："
                    placeholder={`例：${API.SITE_URL}`}
                    onPressEnter={(e) => e.preventDefault()}
                    allowClear
                  />
                </Form.Item>
                <Form.Item
                  name="linkC"
                  className="mt-4"
                  rules={[
                    {
                      type: "url",
                      message: "入力のURLが有効なURLではありません",
                    },
                  ]}
                >
                  <Input
                    addonBefore="C部分のリンク先："
                    placeholder={`例：${API.SITE_URL}`}
                    onPressEnter={(e) => e.preventDefault()}
                    allowClear
                  />
                </Form.Item>
                <Divider />
                <div className="flex justify-center">
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={richMenuUpdateMutation.isLoading}
                    disabled={
                      defaultRichMenuImageFile?.preview ||
                      defaultRichMenuForm.getFieldValue("richMenuImage")
                        ? false
                        : true
                    }
                  >
                    保存する
                  </Button>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </Modal>
      <Modal
        title="登録後のリッチメニュー編集"
        visible={isMemberRichMenuModalVisible}
        onCancel={hideMemberRichMenuModal}
        footer={null}
        destroyOnClose
        centered
        bodyStyle={{
          maxHeight: "90vh",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        <div className="flex flex-col">
          <Divider>登録後のリッチメニュー</Divider>
          <div className="flex flex-col justify-center bg-amber-50 p-4 rounded mb-4">
            <Image
              src="/template.png"
              alt="テンプレート"
              preview={{
                mask: <AiOutlineEye />,
                src: "/template.png",
                maskClassName: "rounded",
              }}
              className="w-full rounded object-contain"
              fallback="/no-image.png"
            />
            <p className="my-4">
              リッチメニューの画像は以下の要件を満たす必要があります
            </p>
            <ol className="custom-ol list-none list-outside mb-2">
              <li>画像フォーマット：JPEGまたはPNG</li>
              <li>画像の幅サイズ（ピクセル）：1200px</li>
              <li>画像の高さサイズ（ピクセル）：810px</li>
              <li>最大ファイルサイズ：1MB</li>
            </ol>
          </div>
          <div className="border border-antd-gray p-4">
            <Form
              form={memberRichMenuForm}
              onFinish={(data) => {
                handleRichMenuUpdate("memberRM", memberRichMenuImageFile, data)
              }}
              layout="vertical"
              requiredMark={false}
              preserve={false}
              initialValues={{
                richMenuImage: undefined,
              }}
              scrollToFirstError
            >
              <div className="flex flex-col">
                <Form.Item
                  name="richMenuImage"
                  className="whitespace-pre-wrap text-center"
                  help={`※このリッチメニューは、会員のユーザーに\n表示されます`}
                  valuePropName="file"
                >
                  <CustomUpload
                    accept=".jpg, .jpeg, .png"
                    listType="picture"
                    maxCount={1}
                    showUploadList={false}
                    beforeUpload={() => {
                      return false
                    }}
                    onChange={async (param) => {
                      checkRichMenuImageSize(
                        "memberRM",
                        param,
                        setMemberRichMenuImageFile
                      )
                    }}
                  >
                    {memberRichMenuImageFile?.preview ? (
                      <img
                        src={memberRichMenuImageFile.preview}
                        alt="登録後のリッチメニュー"
                        style={{
                          maxHeight: "250px",
                        }}
                        className="w-full object-contain cursor-pointer"
                      />
                    ) : (
                      <div
                        style={{
                          height: "250px",
                          backgroundColor: "#fafafa",
                          border: "1px dashed #d9d9d9",
                        }}
                        className="flex justify-center items-center rounded cursor-pointer"
                      >
                        <Button
                          type="dashed"
                          icon={<FaCamera className="text-primary anticon" />}
                        >
                          アップロード
                        </Button>
                      </div>
                    )}
                  </CustomUpload>
                </Form.Item>
                <Divider />
                <Form.Item
                  name="linkA"
                  className="mt-4"
                  rules={[
                    {
                      type: "url",
                      message: "入力のURLが有効なURLではありません",
                    },
                  ]}
                >
                  <Input
                    addonBefore="A部分のリンク先："
                    placeholder={`例：${API.SITE_URL}`}
                    onPressEnter={(e) => e.preventDefault()}
                    allowClear
                  />
                </Form.Item>
                <Form.Item
                  name="linkB"
                  className="mt-4"
                  rules={[
                    {
                      type: "url",
                      message: "入力のURLが有効なURLではありません",
                    },
                  ]}
                >
                  <Input
                    addonBefore="B部分のリンク先："
                    placeholder={`例：${API.SITE_URL}`}
                    onPressEnter={(e) => e.preventDefault()}
                    allowClear
                  />
                </Form.Item>
                <Form.Item
                  name="linkC"
                  className="mt-4"
                  rules={[
                    {
                      type: "url",
                      message: "入力のURLが有効なURLではありません",
                    },
                  ]}
                >
                  <Input
                    addonBefore="C部分のリンク先："
                    placeholder={`例：${API.SITE_URL}`}
                    onPressEnter={(e) => e.preventDefault()}
                    allowClear
                  />
                </Form.Item>
                <Divider />
                <div className="flex justify-center">
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={richMenuUpdateMutation.isLoading}
                    disabled={
                      memberRichMenuImageFile?.preview ||
                      memberRichMenuForm.getFieldValue("richMenuImage")
                        ? false
                        : true
                    }
                  >
                    保存する
                  </Button>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default RichMenu
